import { render, staticRenderFns } from "./selfView.vue?vue&type=template&id=0221b9dc&"
import script from "./selfView.vue?vue&type=script&lang=js&"
export * from "./selfView.vue?vue&type=script&lang=js&"
import style0 from "./selfView.vue?vue&type=style&index=0&id=0221b9dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports